import styled, { css } from 'styled-components';
import { Stack } from '@mui/material';

export const flex = css`
  display: flex;
`;

export const Flex = styled(Stack).attrs({ direction: 'row' })``;
